module.exports = __webpack_public_path__ + "img/第9届区域服务经理推介会.fb904c88.jpg";